export function BatteryProgress({
  value,
  level,
  text,
}: {
  value: number;
  level: number | undefined;
  text?: string;
}) {
  const fillColor =
    level === 255
      ? 'var(--color-primary)'
      : level !== undefined && level < 80
        ? 'var(--color-error)'
        : 'var(--color-primary)';

  return (
    <div
      className="relative flex items-center justify-center h-5 w-[120px] max-w-[100%] overflow-hidden rounded-[5px]"
      style={{ backgroundColor: 'var(--bg-surface-2)' }}
    >
      <div
        className="absolute left-0 top-0 h-full rounded-[5px] transition-all duration-300 z-0"
        style={{
          width: `${Math.max(0, Math.min(100, value))}%`,
          backgroundColor: fillColor,
        }}
      />
      {text && (
        <span className="relative z-10 text-[11px] font-bold text-white drop-shadow-md">
          {text}
        </span>
      )}
    </div>
  );
}
